// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a5947886a1052dad2daf","655":"35fdb6a88e7e485a120d"}[chunkId] + ".js";
};